<template>
  <confirm-modal ref="modal" title="Удаление анкеты" confirm="Удалить" reset="Отменить" mode="danger" @confirm="confirm">
    <span> Анкета <b>{{ name }}</b> будет удалена без возможности восстановления </span>
  </confirm-modal>
</template>

<script>
import ConfirmModal from "@/components/modals/confirm-modal";

export default {
  components: { ConfirmModal },
  data() {
    return {
      id: null,
      name: "",
    };
  },
  computed: {},
  methods: {
    open(item) {
      this.id = item.id;
      this.name = item.name;

      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
      this.id = null;
      this.name = "";
    },
    confirm() {
      this.$store.dispatch("profile/deleteProfile", this.id).then(() => {
        this.$notify({
          group: "success-message",
          data: {
            textMessage: `Анкета <b>${this.name}</b> успешно удалена`,
          },
        });
        this.close();

        this.$emit("remove", this.id);
      });
    },
  },
};
</script>
